<template>
    <div class="logo text-center">
        <img src="~@/assets/images/odrex-logo-ua.svg" alt="odrex">
    </div>
</template>

<script>
    export default {
        name: 'logo'
    }
</script>

<style scoped lang="scss">
    .logo {
        & > img {
            width: 150px;
            /*height: 30px;*/
        }
    }
</style>
